import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Header } from "@/components/Header";
import { Button } from "@/components/ui/button";

export function PaymentSuccess() {
  const { lang } = useLang();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking"); // checking | paid | timeout

  useEffect(() => {
    if (!sessionId) { setStatus("timeout"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch {}
      if (attempts >= 8) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-lg mx-auto px-4 py-20 text-center space-y-5">
        {status === "checking" && (<><Loader2 className="h-12 w-12 mx-auto animate-spin text-primary" /><p className="text-lg text-muted-foreground">{lang === "es" ? "Confirmando tu pago..." : "Confirming your payment..."}</p></>)}
        {status === "paid" && (
          <>
            <CheckCircle2 className="h-16 w-16 mx-auto text-primary" />
            <h1 className="font-heading font-extrabold text-3xl">{lang === "es" ? "¡Suscripción activada!" : "Subscription active!"}</h1>
            <p className="text-muted-foreground">{lang === "es" ? "Gracias. Tu plan de Brilla ya está activo." : "Thank you. Your Brilla plan is now active."}</p>
            <Button onClick={() => navigate("/dashboard")} className="rounded-full bg-secondary hover:bg-secondary/90" data-testid="success-dashboard">{lang === "es" ? "Ir al panel" : "Go to Dashboard"}</Button>
          </>
        )}
        {status === "timeout" && (
          <>
            <Loader2 className="h-12 w-12 mx-auto text-muted-foreground" />
            <h1 className="font-heading font-bold text-2xl">{lang === "es" ? "El pago se está procesando" : "Payment is processing"}</h1>
            <p className="text-muted-foreground">{lang === "es" ? "Esto puede tardar un momento. Revisa tu plan en Precios." : "This can take a moment. Check your plan under Pricing."}</p>
            <Link to="/pricing"><Button variant="outline" className="rounded-full">{lang === "es" ? "Ver Precios" : "View Pricing"}</Button></Link>
          </>
        )}
      </main>
    </div>
  );
}

export function PaymentCancel() {
  const { lang } = useLang();
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-lg mx-auto px-4 py-20 text-center space-y-5">
        <XCircle className="h-16 w-16 mx-auto text-secondary" />
        <h1 className="font-heading font-extrabold text-3xl">{lang === "es" ? "Pago cancelado" : "Payment cancelled"}</h1>
        <p className="text-muted-foreground">{lang === "es" ? "No se realizó ningún cargo." : "No charge was made."}</p>
        <Link to="/pricing"><Button className="rounded-full bg-secondary hover:bg-secondary/90" data-testid="cancel-back">{lang === "es" ? "Volver a Precios" : "Back to Pricing"}</Button></Link>
      </main>
    </div>
  );
}
